import { render, staticRenderFns } from "./SessionSubPage.vue?vue&type=template&id=22650196&scoped=true&"
import script from "./SessionSubPage.vue?vue&type=script&lang=ts&"
export * from "./SessionSubPage.vue?vue&type=script&lang=ts&"
import style0 from "./SessionSubPage.vue?vue&type=style&index=0&id=22650196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22650196",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
